// extracted by mini-css-extract-plugin
export var legendIndicator = "_f7-1";
export var legendRight = "_f7-0";